/* eslint-disable */
<template>
  <div>
    <el-row>
      <el-col :span="17">
        <!-- 面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
          <!--            <el-breadcrumb-item>Factory Id:{{factory.id}} Supplier:{{factory.supplier}} Location:{{factory.location}} </el-breadcrumb-item>-->
          <el-breadcrumb-item>Output(M/W/D)</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-card>
<!--      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">-->
<!--        <el-tab-pane label="Week" name="1">-->
<!--          <div style="display: flex">-->
<!--            <el-date-picker-->
<!--              style="flex: 1"-->
<!--              v-model="dateRange"-->
<!--              type="daterange"-->
<!--              align="right"-->
<!--              unlink-panels-->
<!--              range-separator="-"-->
<!--              start-placeholder="Starts Date"-->
<!--              end-placeholder="End Date"-->
<!--              value-format="yyyy-MM-dd"-->
<!--              :disabled-date="disabledDate"-->
<!--              :picker-options="pickerOptions">-->
<!--            </el-date-picker>-->
<!--            <el-select-->
<!--              style="width: 100%;flex: 1"-->
<!--              v-model="value"-->
<!--              multiple-->
<!--              filterable-->
<!--              remote-->
<!--              reserve-keyword-->
<!--              placeholder="Keyword search by item"-->
<!--              :remote-method="remoteMethod"-->
<!--              :loading="loading">-->
<!--              <el-option-->
<!--                v-for="item in options"-->
<!--                :key="item.value"-->
<!--                :value="item">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--            <el-button type="primary" @click="onSubmit3()">Submit</el-button>-->
<!--          </div>-->
<!--          <el-card>-->
<!--            <div style="width:1200px;height:450px" ref="chart"></div>-->
<!--          </el-card>-->
<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="Day" name="2">-->
<!--          <el-table-->
<!--            :data="tableList"-->
<!--            style="width: 100%">-->
<!--            <el-table-column-->
<!--              prop="picUrl"-->
<!--              label="Pic"-->
<!--              width="200">-->
<!--              <template slot-scope="scope">-->
<!--                <img :src="scope.row.picUrl" min-width="30" height="30" @click="showpreviewPic(scope.row.picUrl,scope.row.items)">-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="quantity"-->
<!--              label="Quantity"-->
<!--              width="200">-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="items"-->
<!--              label="Items"-->
<!--              show-overflow-tooltip-->
<!--              width="200">-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="type"-->
<!--              label="Type"-->
<!--              width="200">-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="factory"-->
<!--              label="Factory"-->
<!--              width="150">-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="machine"-->
<!--              label="Machine ID"-->
<!--              width="150">-->
<!--            </el-table-column>-->
<!--            &lt;!&ndash;            <el-table-column label="Operation" width="90" fixed="right">&ndash;&gt;-->
<!--            &lt;!&ndash;              <template slot-scope="index">&ndash;&gt;-->
<!--            &lt;!&ndash;                &lt;!&ndash;                <el-button type="info" plain size="mini" @click="deleteN(index)">Update</el-button>&ndash;&gt;&ndash;&gt;-->
<!--            &lt;!&ndash;                <el-button type="danger" plain size="mini" @click="deleteN(index)">Delete</el-button>&ndash;&gt;-->
<!--            &lt;!&ndash;              </template>&ndash;&gt;-->
<!--            &lt;!&ndash;            </el-table-column>&ndash;&gt;-->
<!--          </el-table>-->
<!--        </el-tab-pane>-->
<!--&lt;!&ndash;        <el-tab-pane label="Item Production Query(Machine)" name="3">&ndash;&gt;-->
<!--&lt;!&ndash;        </el-tab-pane>&ndash;&gt;-->

<!--      </el-tabs>-->
      <div style="display: flex">
        <el-date-picker
          style="flex: 1"
          v-model="dateRange"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="-"
          start-placeholder="Starts Date"
          end-placeholder="End Date"
          value-format="yyyy-MM-dd"
          :disabled-date="disabledDate"
          :picker-options="pickerOptions">
        </el-date-picker>
        <el-select
          style="width: 100%;flex: 1"
          v-model="value"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="Keyword search by item"
          :remote-method="remoteMethod"
          :loading="loading">
          <el-option
            v-for="item in options"
            :key="item.value"
            :value="item">
          </el-option>
        </el-select>
        <el-button type="primary" @click="onSubmit3()">Submit</el-button>
      </div>

    </el-card>
    <el-card>
      <div style="width:1200px;height:450px" ref="chart"></div>
    </el-card>
<!--    <el-card>-->
<!--      <div style="width:1200px;height:450px" ref="chart"></div>-->
<!--    </el-card>-->
<!--    <el-dialog :visible.sync="lookdialogVisible" :modal="false" title="Items:" width="30%">-->
<!--      <p>{{items}}</p>-->
<!--      <img :src="previewpic" alt=""  width="100%" />-->
<!--    </el-dialog>-->
  </div>
</template>

<script>
import * as echarts from 'echarts/lib/echarts'
import axios from 'axios'

export default {
  name: 'Output',
  data () {
    return {
      itemlist: [],
      list1: [],
      list2: [],
      list3: [],
      lastDate: '',
      // activeName: '1',
      itemsDis: [],
      itemsChoose: [],
      newItems: [],
      options: [],
      value: [],
      loading: false,
      seriesVar: [],
      // items: [],
      quanReportList: [],
      form: [],
      brandList: [],
      factory: '',
      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last month',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last 3 months',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      tableData1: [],
      // tableData1: [{
      //   id: 1,
      //   date: '2016-05-02',
      //   name: '1',
      //   address: 'TECH',
      //   hasChildren: true
      // }, {
      //   id: 2,
      //   date: '2016-05-04',
      //   name: '1',
      //   address: 'TECH',
      //   hasChildren: true
      // }],
      dateRangeVar: [],
      dateRange: [],
      items: '',
      lookdialogVisible: false,
      previewpic: '',
      // http://localhost:8081/file/upload/img/
      uploadImgUrl: axios.defaults.baseURL + '/file/upload/img/',
      activeName: '1',
      tableList: [
        {
          id: '1752886838036672513',
          machineId: '1',
          jointItemId: null,
          items: '32051-CP3',
          subComponent: '0',
          status: '1',
          quantity: '5780',
          picUrl: 'https://www.myirequest.com:8081/2eb30b15b8634cb9a11ee26b8cab5340.png',
          type: 'Injection',
          factory: 'TECH ID:1',
          machine: '1'
        }
      ]
    }
  },
  mounted () {
    function timestampToTime (times) {
      const year = new Date().getFullYear()
      const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1
      const day = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
      return year + '-' + month + '-' + day
    }
    const time = new Date()
    // const startT = new Date()
    // startT.setTime(new Date().getTime() - 3600 * 1000 * 24 * 30)
    const nowTime = timestampToTime(time.toLocaleString('en-US', { hour12: false }).split(' '))
    const currentDate = new Date()
    currentDate.setMonth(currentDate.getMonth() - 1)
    const year = currentDate.getFullYear()
    const month = String(currentDate.getMonth() + 1).padStart(2, '0')
    const day = String(currentDate.getDate()).padStart(2, '0')
    const formattedDate = `${year}-${month}-${day}`
    // console.log('一个月前的日期:', formattedDate)
    // console.log(nowTime)
    this.dateRange = [formattedDate, nowTime]
    console.log(this.dateRange)
    this.$http.get('/machine/getOutputByTime?startDate=' + this.dateRange[0] + '&&endDate=' + this.dateRange[1])
      .then((resss) => {
        // this.itemsDis = this.itemsDis.concat(resss.data)
        console.log(resss.data)
        this.itemlist = []
        this.list1 = []
        this.list2 = []
        this.list3 = []
        for (let i = 0; i < resss.data.length; i++) {
          this.itemlist.push(resss.data[i].items)
          this.list1.push(resss.data[i].quantity.toFixed(0))
          this.list2.push((resss.data[i].quantity * 6).toFixed(0))
          this.list3.push((resss.data[i].quantity * 24).toFixed(0))
        }

        const myChart = echarts.init(this.$refs.chart)
        myChart.setOption({
          dataZoom: [
            {
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              start: 1,
              end: 100,
              bottom: '20'
            }
          ],
          title: {
            // text: 'Weekly Output'
          },
          label: { // 柱状图 内部 显示数值
            show: true
          },
          tooltip: {},
          legend: {
            data: ['Month', 'Week', 'Day']
          },
          xAxis: {
            axisLabel: {
              interval: 0,
              rotate: 30
            },
            data: this.itemlist
            // data: ['CP-001', 'CP-002']
          },
          yAxis: {},
          series: [
            {
              name: 'Month',
              type: 'bar',
              data: this.list3
            },
            {
              name: 'Week',
              type: 'bar',
              data: this.list2
            },
            {
              name: 'Day',
              type: 'bar',
              data: this.list1
            }
          ]
        }, true)
      })
  },
  created () {
  },
  methods: {
    onSubmit3 () {
      console.log(this.value)
      const itemsList = []
      for (let i = 0; i < this.value.length; i++) {
        itemsList.push(this.value[i].split('|')[0])
      }
      this.$http.get('/machine/getOutputByTime?startDate=' + this.dateRange[0] + '&&endDate=' + this.dateRange[1] + '&&items=' + itemsList)
        .then((resss) => {
          // this.itemsDis = this.itemsDis.concat(resss.data)
          console.log(resss.data)
          this.itemlist = []
          this.list1 = []
          this.list2 = []
          this.list3 = []
          for (let i = 0; i < resss.data.length; i++) {
            this.itemlist.push(resss.data[i].items)
            this.list1.push(resss.data[i].quantity.toFixed(0))
            this.list2.push((resss.data[i].quantity * 6).toFixed(0))
            this.list3.push((resss.data[i].quantity * 24).toFixed(0))
          }
          const myChart = echarts.init(this.$refs.chart)
          myChart.setOption({
            dataZoom: [
              {
                type: 'slider',
                show: true,
                xAxisIndex: [0],
                start: 1,
                end: 100,
                bottom: '20'
              }
            ],
            title: {
              // text: 'Weekly Output'
            },
            label: { // 柱状图 内部 显示数值
              show: true
            },
            tooltip: {},
            legend: {
              data: ['Month', 'Week', 'Day']
            },
            xAxis: {
              axisLabel: {
                interval: 0,
                rotate: 30
              },
              data: this.itemlist
              // data: ['CP-001', 'CP-002']
            },
            yAxis: {},
            series: [
              {
                name: 'Month',
                type: 'bar',
                data: this.list3
              },
              {
                name: 'Week',
                type: 'bar',
                data: this.list2
              },
              {
                name: 'Day',
                type: 'bar',
                data: this.list1
              }
            ]
          }, true)
        })
    },
    async remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        await this.$http.get('/machine/getListByKeyword?keyword=' + query)
          .then((ress) => {
            this.options = ress.data
            this.newItems = ress.data
          })
        setTimeout(() => {
          this.loading = false
          this.options = this.newItems.filter(item => {
            return item.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    disabledDate (time) {
      console.log(time.getTime())
    },
    showpreviewPic (url, items) {
      this.items = items
      this.previewpic = url
      this.lookdialogVisible = true
    }
  }
}
</script>

<style scoped>
</style>
